<template>
    <van-popup v-model:show="show" position="right" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: 'green',
        color: '#fff',
        overflow: 'hidden',
    }">
        <div class="popupContainer">
            <CustomHeader :text="$t('activity.bonuRegistation')" :is-popup-close-back-icon="true" @closePopup="close" bgColor="#101423" />

            <div class="historyContainer" v-if="!isUseFirstRecharge">
                <div class="tabelContainer">
                    <!-- <div class="tabelTitle">
                        <img src="@/assets/vip/db.png" alt="">
                        {{ $t('vip.registerCollection') }}
                    </div> -->
                    <van-row class="tabelHead" justify="space-between">
                        <van-col span="10" class="headCol">{{
                            $t('vip.time') }}</van-col>
                        <van-col span="7" class="headCol">{{ $t('vip.eventName')
                            }}</van-col>
                        <van-col span="6" class="headCol">{{ $t('vip.money') }}</van-col>
                    </van-row>
                    <van-row class="tabeldata" v-for="(item, index) in historyList" :key="index" justify="space-between"
                        :style="{ background: Number(index) % 2 == 0 ? '#1a1d22' : 'transparent' }">
                        <van-col span="10" class="headCol">{{ item.updateTime }}</van-col>
                        <van-col span="7" class="headCol">{{ item.rewardType == 1 ? $t('vip.upgrade') : item.rewardType
                            == 2 ? $t('vip.weekly') : item.rewardType == 3 ? $t('vip.monthly') : item.rewardType == 4 ?
                                $t('vip.daily') : '' }}</van-col>
                        <van-col span="6" class="headCol">{{ item.coin }}</van-col>
                    </van-row>
                </div>


                <NoData v-if="historyList?.length <= 0" />

                <van-row v-else-if="total > pageNum * pageSize">
                    <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                            @click="getNextPageRewardData"></van-col>
                </van-row>
                <div v-else class="no_more">{{ $t('message.noMore') }}</div>
            </div>


        </div>

    </van-popup>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref, PropType } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import CustomHeader from '@/themes/themeThree/components/common/customHeader.vue';
import NoData from '@/themes/themeThree/components/common/noData.vue';
import { getVIPRewardHistory } from '@/api/activity';
import { getVIPHistoryDataFunc } from '@/view/vip/supportScript'
const PAGE_SIZE = 20
const props = defineProps({
    list: {
        type: Array as PropType<(any)[]>,
        default: () => []
    },
    showIcon: {
        type: Boolean
    },
    isUseFirstRecharge: {
        type: Boolean,
        default: () => false
    }
})
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const pageSize = ref(PAGE_SIZE)
const pageNum = ref(1)
const total = ref(0)
const historyList = ref<any[]>([])
const emits = defineEmits(['updateHistoryList'])
const open = (data: any) => {
    show.value = true
    getVIPHistoryData()
}

const close = () => {
    show.value = false
    historyList.value = []
    total.value = 0
    pageNum.value = 1
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const getVIPHistoryData = () => {
    getVIPHistoryDataFunc(getVIPRewardHistory, loadingRef, pageNum, pageSize, total, historyList, showError)
}
const getNextPageRewardData = () => {
    if (total.value > pageNum.value * pageSize.value) {
        pageNum.value = pageNum.value + 1
        loadingRef.value.open()
        getVIPHistoryData()
    }
}
defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    background: #090F1F;
    background-size: cover;
    background-repeat: repeat;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    font-size: 14px;
}

.historyContainer {
    padding: 50px 25px;
    height: calc(100vh - 25px);
    overflow-y: auto;
    box-sizing: border-box;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.historyContainer::-webkit-scrollbar {
    display: none;
}

.tabelContainer {
    padding: 25px 0 0;
}

.tabelTitle {
    background-image: linear-gradient(270deg, #3c3573, #4e346b);
    border-radius: 15px 15px 0 0;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 15px;
}

.tabelTitle img {
    width: 20px;
    padding-right: 5px;
}

.tabelHead {
    background: #1a223a;
    color: #fff;
    margin: 1px 0;
    padding: 10px;
}

.headCol {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 30px;
    transform: rotate(-90deg);
}

.tabeldata {
    background: #ffffff0a;
    color: #6b6f79;
    margin: 1px 0;
    padding: 15px 10px;
    font-size: 14px;

}

.checkinPopContainer {
    padding: 50px 0;
}

.headBar {
    background-color: #2f1f10;
    padding: 10px;
}

.headText {
    padding: 5px;
    /* font-size: 10px; */
    font-weight: 600;
}

.headText span {
    color: #FFF000;
    padding: 03px;
}

.no_more {
    color: #969799;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
}
</style>